import React, { useState, useEffect, useRef } from 'react';
import { useDispatch, useSelector } from 'react-redux';

import {
  makeStyles, Typography, Box, Modal, Button, Snackbar, FormControlLabel, Checkbox
} from '@material-ui/core';
import { APP_NAME } from '../../config/constant';
import { Link, Stack } from '@mui/material';
import LoginAgreeSection from './LoginAgreeSection';

const modalStyle = {
  position: 'absolute',
  top: '50%',
  left: '50%',
  transform: 'translate(-50%, -50%)',
  width: '90%',
  maxWidth: '440px',
  bgcolor: 'background.paper',
  boxShadow: 24,
  p: 3,
};
const useStyles = makeStyles(() => ({
  details: {
    flexDirection: 'column',
  },
  buttons: {
    display: 'flex',
    justifyContent: 'space-evenly',
    '& > *': {
      flexBasis: '30%',
    },
  },
}));

const LoginAgreeModal = (props) => {
  const dispatch = useDispatch();
  const classes = useStyles();
  const { open, setOpen, onClickAgree, onClickCancel } = props;

  const handleModalClose = () => {
    setOpen(false)
  }
  const [snackbarOpen, setSnackbarOpen] = useState(false);
  const [toastMessage, setToastMessage] = useState("");

  return (
    <>
      <Modal
        open={open}
        onClose={handleModalClose}
        aria-labelledby="parent-modal-title"
        aria-describedby="parent-modal-description"
      >
        <Box sx={modalStyle}>
          <Snackbar
            anchorOrigin={{ vertical: 'top', horizontal: 'center' }}
            open={snackbarOpen}
            onClose={() => { setSnackbarOpen(false) }}
            autoHideDuration={1500}
            message={toastMessage}
          />
          <Typography id="modal-modal-title" variant="h6" component="h6">{APP_NAME}</Typography>

          <LoginAgreeSection
            onClickAgree={onClickAgree}
          />

          <div className={classes.buttons} style={{ width: '100%' }}>
            <Button type="button" color="primary" variant="outlined" onClick={() => setOpen(false)}>
              Close
            </Button>
          </div>
        </Box>
      </Modal>
    </>
  );
};

export default LoginAgreeModal;
